import { render, staticRenderFns } from "./distributors-widget.vue?vue&type=template&id=6ac511fc&"
import script from "./distributors-widget.vue?vue&type=script&lang=js&"
export * from "./distributors-widget.vue?vue&type=script&lang=js&"
import style0 from "./distributors-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports